export default "__VITE_ASSET__0JFZHNOH__"